import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';

import { useGetContractQuery } from '@/apis/extended/contractApi';
import { Button } from '@/components/ui/button';

// type ContractDetailProps = {
//   contractId: string;
// };

export const ContractDetailAgentSuccess = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { uid } = useParams();

  // Get contract data to check status
  const { data: contract, isLoading } = useGetContractQuery(uid || '', {
    skip: !uid,
  });

  if (isLoading) {
    return (
      <Box
        sx={{
          py: '40px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
        }}
      >
        <Typography variant="body1">Loading...</Typography>
      </Box>
    );
  }

  const isRatified = contract?.contractStatus === 'ratified';

  return (
    <Box
      sx={{
        py: '40px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
      }}
    >
      <i
        className="fa-light fa-badge-check"
        style={{ color: theme.palette.success.main, fontSize: '96px' }}
      />
      <Typography variant="h2" sx={{ mt: 4 }}>
        {isRatified ? 'Contract Ratified!' : 'Details Submitted!'}
      </Typography>
      <Typography variant="body1" sx={{ mt: 4, lineHeight: '24px' }}>
        {isRatified ? (
          <>
            Congratulations! The contract has been ratified by all parties.
            <br />
            You can now access the Property Dashboard to manage the transaction.
          </>
        ) : (
          <>
            Thank you for submitting the Details.
            <br />
            Please wait while we process your submission.
            <br />
            We will notify you with any updates or further steps required.
          </>
        )}
      </Typography>
      <Box
        sx={{
          mt: 4,
          display: 'flex',
          gap: 2,
          flexDirection: { xs: 'column', sm: 'row' },
        }}
      >
        {isRatified ? (
          <>
            <Button
              className="items-center"
              variant="outline"
              color="primary"
              onClick={() => navigate(`/agent/property-dashboard/${uid}`)}
            >
              <i className="fa-light fa-chart-line mr-2" /> Property Dashboard
            </Button>
            <Button
              className="items-center"
              variant="outline"
              color="primary"
              onClick={() => navigate(`/view-contract/${uid}`)}
            >
              <i className="fa-light fa-eye mr-2" /> Review Contract
            </Button>
          </>
        ) : (
          <Button
            className="items-center"
            variant="outline"
            color="primary"
            onClick={() => navigate(`/view-contract/${uid}`)}
          >
            <i className="fa-light fa-eye mr-2" /> View Contract
          </Button>
        )}
      </Box>
    </Box>
  );
};
